module.exports = __webpack_public_path__ + "css/Smartflower.b80c9a75.css";